exports.en = {
  NO_DATA: 'No data found for selected fund.',
  TITLE: 'Securities',
  CZK: 'CZK',
  NAME: 'Name',
  TYPE: 'Type',
  REPRESENTATION: 'Proportion',
  ISIN: 'ISIN'
}
